/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_CallInputs */

const en_home_hero_cta_call = /** @type {(inputs: Home_Hero_Cta_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a discovery call`)
};

const lv_home_hero_cta_call = /** @type {(inputs: Home_Hero_Cta_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieteikt iepazīšanās sarunu`)
};

/**
* | output |
* | --- |
* | "Book a discovery call" |
*
* @param {Home_Hero_Cta_CallInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_cta_call = /** @type {((inputs?: Home_Hero_Cta_CallInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_CallInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_cta_call(inputs)
	return en_home_hero_cta_call(inputs)
});